import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/img/logo/alert.svg'


const _hoisted_1 = {
  class: "fixed top-0 left-0 w-screen h-screen flex justify-center items-center",
  style: {"z-index":"990"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "absolute top-0 left-0 w-full h-full bg-black opacity-50" }, null, -1)
const _hoisted_3 = {
  class: "sm:w-[320px] w-8/12 sm:h-52 h-40 bg-white flex flex-col justify-center items-center text-lg rounded-[10px] mb-20",
  style: {"z-index":"999","box-shadow":"0px 0px 20px rgba(8, 50, 25, 0.12)"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "alert",
  class: "sm:w-6 w-4 sm:mb-[10px]"
}, null, -1)
const _hoisted_5 = { class: "justify-center items-center text-center sm:mb-3 mb-1 h-14 flex" }
const _hoisted_6 = { class: "whitespace-pre-wrap text-[15px] sm:text-lg leading-[22px]" }
const _hoisted_7 = { class: "flex sm:w-11/12 sm:mt-[2px] mt-0 w-11/12 px-4" }

import { ref } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmModal',
  props: {
    content1: {
        type: String,
        required: true,
    },

    closeButton: {
        type: String,
        required: true,
    },
    okayButton: {
        type: String,
    }
},
  emits: ['updateClose', 'updateOkay'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit;

// 선택된 값이 변경될 때 부모 컴포넌트에 알림
const emitToParent = () => {
    emit('updateClose');
};
const updateOkay = () => {
    emit('updateOkay')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, _toDisplayString(props.content1), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        (props.okayButton)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "bg-pada w-full h-10 text-base font-medium rounded-md text-white mr-4",
              onClick: updateOkay
            }, _toDisplayString(props.okayButton), 1))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: _normalizeClass(["w-full h-10 font-medium rounded-md text-white sm:text-base text-sm", {'bg-pada': !props.okayButton, 'bg-zinc-100 text-zinc-700': props.okayButton}]),
          onClick: emitToParent
        }, _toDisplayString(props.closeButton), 3)
      ])
    ])
  ]))
}
}

})